import React from "react";

import InputLabel from "components/inputfields/InputLabel";
import ListDropDown from "components/inputfields/ListDropDown";

import {
  complianceMetalsSkinContact,
  confirmGuidanceSwedishElectronics,
  complianceToyDirective,
  complianceBiocid,
  complianceBiocidalTreated,
} from '../../../constants-ts';


import IProduct from "models/product";
import { IFoodlaCategoryOption } from "models/category";
import { useProductValidations } from '../validation-context/ProductValidationContext';
import { getProductFieldVisibility } from '../utils/productFieldVisibility';

interface IAdditionalGroupFieldsDataProps {
  readOnly?: boolean;
  state: IProduct;
  setState: (state: IProduct) => void;
  rootCategory: IFoodlaCategoryOption;
};

const AdditionalGroupFields = ({ readOnly, state, setState, rootCategory}: IAdditionalGroupFieldsDataProps) => {
  const { requiredFields } = useProductValidations();
  const { fields } = getProductFieldVisibility({ product: state, rootCategory });
  const handleDropdownChange = (
    event: React.ChangeEvent<{
        name?: string | undefined;
        value: unknown;
    }>,
  ) => {
      const stateName = event.target.name;
      let stateValue = event.target.value;

      const val = !stateValue || stateValue === '' ? null : stateValue;
      stateName && setState({ ...state, [stateName]: val });
  };

  return (
    <div style={{width: '100%'}}>
      {fields.complianceMetalsSkinContact && (
        <>
          <InputLabel
            required={!!requiredFields.complianceMetalsSkinContact}
            heading="Uppfyller produkten reglerna om skadliga tungmetaller (t.ex. nickel, kadmium eller bly) i bilaga XVII till Reach-förordningen?"
            text="T.ex. smycken, glasögon, klockor, accessoarer, underkläder etc. Eftersom smycken bärs nära huden och ofta är gjorda av flera olika material som kan innehålla skadliga ämnen, finns det en risk att ämnen som är farliga för människor kan komma in i kroppen."
            link="https://www.kemi.se/lagar-och-regler/regler-for-nagra-produktgrupper/smycken---kort-om-regler"
          />
          <ListDropDown
            readOnly={readOnly}
            disableLabel={true}
            listData={complianceMetalsSkinContact}
            value={state?.complianceMetalsSkinContact}
            targetName="complianceMetalsSkinContact"
            handleChange={handleDropdownChange}
            displayEmpty={true}
          />
        </>
      )}
      {fields.confirmGuidanceSwedishElectronics && (
          <>
            <InputLabel
              required={!!requiredFields.confirmGuidanceSwedishElectronics}
              heading="Om produkten är elektrisk/elektronisk, finns det svensk bruksanvisning bifogad på förpackningen?"
              text="Alla elektriska produkter som säljs i Sverige måste ha säkerhetsinformation och bruksanvisning på svenska."
              link="https://www.elsakerhetsverket.se/fragor-och-svar/arkiv-fragor/Svensk-bruksanvisning/"
            />
            <ListDropDown
              readOnly={readOnly}
              disableLabel={true}
              listData={confirmGuidanceSwedishElectronics}
              value={state?.confirmGuidanceSwedishElectronics}
              targetName="confirmGuidanceSwedishElectronics"
              handleChange={handleDropdownChange}
              displayEmpty={true}
            />
          </>
      )}
      {fields.complianceToyDirective && (
          <>
            <InputLabel
              required={!!requiredFields.complianceToyDirective}
              heading="Uppfyller produkten som är en leksak kraven i leksaksdirektivet (EG) 2009/48?"
              text="Leksaksdirektivet 2009/48/EG är ett omfattande regelverk för leksaker som gäller i hela EU och handlar om leksakers säkerhet och innehåller bland annat regler om kemiskt innehåll, brännbarhet, elsäkerhet, dokumentation och märkning."
              link="https://www.kemi.se/lagar-och-regler/lagstiftningar-inom-kemikalieomradet/eu-gemensam-lagstiftning/leksaker---leksaksdirektivet/kort-om-leksaksreglerna---leksaksdirektivet"
            />
            <ListDropDown
              readOnly={readOnly}
              disableLabel={true}
              listData={complianceToyDirective}
              value={state?.complianceToyDirective}
              targetName="complianceToyDirective"
              handleChange={handleDropdownChange}
              displayEmpty={true}
            />
          </>
      )}
      {fields.complianceBiocid && (
          <>
            <InputLabel
              required={!!requiredFields.complianceBiocid}
              heading="Uppfyller varan som är en biocidprodukt kraven i EUs biocidförordning 528/2012?"
              text="Förordning (EU) 528/2012 avser utsläppande på marknaden och användning av biocidprodukter som används för att skydda människor, djur, material och varor mot skadliga organismer, som skadedjur och bakterier, genom de verksamma ämnena i biocidprodukten."
              link="https://www.kemi.se/lagar-och-regler/lagstiftningar-inom-kemikalieomradet/regler-for-bekampningsmedel/biocider/regler-for-biocider"
            />
            <ListDropDown
              readOnly={readOnly}
              disableLabel={true}
              listData={complianceBiocid}
              value={state?.complianceBiocid}
              targetName="complianceBiocid"
              handleChange={handleDropdownChange}
              displayEmpty={true}
            />
          </>
      )}
      {fields.complianceBiocidalTreated && (
          <>
            <InputLabel
              required={!!requiredFields.complianceBiocidalTreated}
              heading="Uppfyller varan som är biocidbehandlad kraven i EUs biocidförordning 528/2012?"
              text="En biocidbehandlad vara är en vara som är behandlad med en typ av bekämpningsmedel, en så kallad biocidprodukt. Syftet med behandlingen är att ge varan en funktion, till exempel att göra en sporttröja luktfri eller en skärbräda antibakteriell."
              link="https://www.kemi.se/lagar-och-regler/lagstiftningar-inom-kemikalieomradet/regler-for-bekampningsmedel/biocider/biocidbehandlade-varor"
            />
            <ListDropDown
              readOnly={readOnly}
              disableLabel={true}
              listData={complianceBiocidalTreated}
              value={state?.complianceBiocidalTreated}
              targetName="complianceBiocidalTreated"
              handleChange={handleDropdownChange}
              displayEmpty={true}
            />
          </>
      )}
      
    </div>
  );
}

export default AdditionalGroupFields;
